export enum RoutesEnum {
  ABOUT = 'about',
  ALL = 'vse_dokumenty',
  CALC = 'kalkulyator',
  COMPANY = 'company',
  CONSUMERS = 'potrebitelyam',
  DOCUMENTS = 'raskrytie_informacii',
  DOWNLOAD = 'download',
  HOME ='/',
  MANAGMENT = 'management',
  MAP = 'karta_prisutstviya',
  SHUTDOWNS = 'otklyucheniya',
  CABINET = 'cabinet',
  CONNECTION = 'connection',
}

export enum PagesEnum {
  ABOUT = 5,
  ALL = 7,
  CALC = 3,
  COMPANY = 4,
  CONSUMERS = 1,
  DOCUMENTS = 2,
  HOME =0,
  MANAGMENT = 6,
  SHUTDOWNS = 91,
}